// extracted by mini-css-extract-plugin
export default {"TaskFinished":"TaskFinished_TaskFinished__nWhvO"};